/**
 * CalloutBox — accent-tinted callout block used by SSM and structure
 * explainers for "safety envelope" callouts, ICG summaries, and other
 * emphasized statements that should pop out of the prose.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import { GRAY, withAlpha } from "../../design-system/tokens.js";

export interface CalloutBoxProps {
  /** Small uppercase kicker rendered above the body. */
  readonly eyebrow: string;
  /** Accent color (the box's tint and the eyebrow color). */
  readonly accent: string;
  readonly children: React.ReactNode;
}

export const CalloutBox = React.memo(function CalloutBox({
  eyebrow,
  accent,
  children,
}: CalloutBoxProps): React.JSX.Element {
  return (
    <div
      style={{
        marginTop: "0.75rem",
        padding: "0.75rem",
        backgroundColor: withAlpha(accent, "1A"),
        border: `1px solid ${withAlpha(accent, "44")}`,
        borderRadius: "0.5rem",
      }}
    >
      <div
        style={{
          fontSize: "0.6875rem",
          fontWeight: 700,
          color: accent,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          marginBottom: "0.25rem",
        }}
      >
        {eyebrow}
      </div>
      <div style={{ color: GRAY[700], fontSize: "0.875rem" }}>{children}</div>
    </div>
  );
});
